export default async function getTablero() {
  const endpoint = localStorage.getItem("api");
  const url = endpoint + "fieldsBoard" + "/" + localStorage.getItem("id");

  try {
    const config = { method: "GET", headers: {} };
    const response = await fetch(url, config);
    const json = await response.json();
    return json;
  } catch (error) {
    console.log("Error" + error);
  }
}
